import '../App.css';
import Layout from "../components/Layout";
import { getAuth, createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { useState, React } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { DynamoDBClient } from "@aws-sdk/client-dynamodb";
import { DynamoDBDocumentClient, PutCommand } from "@aws-sdk/lib-dynamodb";
import { docClient } from "../index.js"


const CreateAccount = () => {
    const auth = getAuth()
    const navigate = useNavigate();

    const [authing, setAuthing] = useState(false);
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    // Email sign-in
    const createAccount = async () => {
        try {
            setErrorMessage('')
            setAuthing(true)
            const auth = getAuth();

            const userCredential = await createUserWithEmailAndPassword(auth,email,password);
        
            const user = userCredential.user;
        
            // Update user profile with a username
            await updateProfile(user, {
                username: username
            });

            // Create a user record in DynamoDB
            const command = new PutCommand({
                TableName: "Accounts", // Your DynamoDB table name
                Item: {
                UserId: user.uid,
                email: email,
                username: username,
                createdAt: new Date().toISOString(),
                // Add any additional user data you want to store
                },
                // Optional: Ensure this email hasn't been used before
                ConditionExpression: "attribute_not_exists(email)"
            });
        
            await docClient.send(command);
            localStorage.setItem("isLoggedIn", "true")
            localStorage.setItem("username", username)
            navigate("/")

        } catch (error) {
            console.log(error)
            
            switch (error.code) {
                case "auth/email-already-in-use":
                    setErrorMessage("This email is already registered.");
                    break;
                case "auth/invalid-email":
                    setErrorMessage("Please enter a valid email address.");
                    break;
                case "auth/operation-not-allowed":
                    setErrorMessage("Email/password accounts are not enabled. Please contact support.");
                    break;
                case "auth/weak-password":
                    setErrorMessage("Please choose a stronger password (at least 6 characters).");
                    break;
                default:
                    setErrorMessage("An error occurred during registration.");
                }

            setAuthing(false)

        }
    }

    return (
        <Layout>
            <h1 className="section-title">Join the Troop</h1>

            <div className="panel auth-panel anim-pop">
                <span className="badge badge-banana">🍌 New Monkey Sign Up</span>

                <div className="field-stack">
                    <input
                        className="input"
                        type="username"
                        id="username"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <input
                        className="input"
                        type="email"
                        id="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <input
                        className="input"
                        type="password"
                        id="passwordInput"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>

                {errorMessage && <div className="error-bubble">{errorMessage}</div>}

                <button
                    className="btn btn-xl"
                    onClick={createAccount}
                    disabled={authing}>
                    {authing ? "Building your nest..." : "Create Account"}
                </button>

                <Link className="link-text" to="/login">Already have an account? Login here!</Link>
            </div>
        </Layout>
  );
}

export default CreateAccount;
